import React, { useState } from 'react';
import { Box, Tab, Tabs, Paper } from '@mui/material';
import MainLayout from '../../../components/layout/MainLayout';
import AdminSidebar from '../AdminSidebar';
import AdminOMRTemplateList from './components/AdminOMRTemplateList';
import AdminExamOMRTemplates from './components/AdminExamOMRTemplates';
import AdminOMRSubmissionList from './components/AdminOMRSubmissionList';
import '../Admin.css';
import { FaDesktop } from 'react-icons/fa';

interface AdminOfflineExamPageProps {
  user: {
    name: string;
    role: string;
    avatar?: string;
  };
  onLogout: () => void;
}

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`omr-tabpanel-${index}`}
      aria-labelledby={`omr-tab-${index}`}
      {...other}
      className="mt-6"
      style={{ fontFamily: 'Inter, sans-serif' }}
    >
      {value === index && children}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `omr-tab-${index}`,
    'aria-controls': `omr-tabpanel-${index}`,
  };
}

const AdminOfflineExamPage: React.FC<AdminOfflineExamPageProps> = ({ user, onLogout }) => {
  const [value, setValue] = useState(0);

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  return (
    <MainLayout user={user} onLogout={onLogout} sidebarContent={<AdminSidebar />}>
      <div className="p-6 min-h-screen bg-gray-50">
        <div className="mb-8">
          {/* svg */}
          <div className="flex items-center">

          <h1 className="admin-title">Offline Exam Management</h1>
          </div>
        </div>

        <Paper 
          elevation={0}
          sx={{ 
            borderRadius: '0.5rem',
            backgroundColor: 'white',
            boxShadow: '0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1)',
            fontFamily: 'Inter, sans-serif',
            '& button': {
              fontFamily: 'Inter, sans-serif'
            },
            '& input': {
              fontFamily: 'Inter, sans-serif'
            },
            '& select': {
              fontFamily: 'Inter, sans-serif'
            }
          }}
        >
          <Box sx={{ 
            borderBottom: 1, 
            borderColor: 'divider',
            '& .MuiButtonBase-root': {
              fontFamily: 'Inter, sans-serif'
            }
          }}>
            <Tabs 
              value={value} 
              onChange={handleChange}
              sx={{
                '& .MuiTab-root': {
                  textTransform: 'none',
                  fontSize: '0.875rem',
                  fontWeight: 500,
                  color: 'rgb(107, 114, 128)',
                  fontFamily: 'Inter, sans-serif',
                  '&.Mui-selected': {
                    color: 'rgb(37, 99, 235)',
                  },
                },
                '& .MuiTabs-indicator': {
                  backgroundColor: 'rgb(37, 99, 235)',
                },
                '& .MuiTab-textColorPrimary': {
                  fontFamily: 'Inter, sans-serif'
                }
              }}
            >
              <Tab 
                label="OMR Submissions" 
                {...a11yProps(0)}
                sx={{ 
                  fontFamily: 'Inter, sans-serif',
                  '&.MuiTab-root': {
                    fontFamily: 'Inter, sans-serif'
                  }
                }}
              />
            </Tabs>
          </Box>
          <Box sx={{ 
            p: 3,
            '& .MuiTypography-root': {
              fontFamily: 'Inter, sans-serif'
            },
            '& .MuiButton-root': {
              fontFamily: 'Inter, sans-serif'
            },
            '& .MuiInputBase-root': {
              fontFamily: 'Inter, sans-serif'
            }
          }}>
            <TabPanel value={value} index={0}>
              <AdminOMRSubmissionList />
            </TabPanel>
          </Box>
        </Paper>
      </div>
    </MainLayout>
  );
};

export default AdminOfflineExamPage; 